import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  View,
  Text,
  StyleSheet,
  Platform,
  TouchableOpacity,
  Linking,
  FlatList,
} from "react-native";
import { Color, globalStyle } from "../assets";
import {force_update, logoName, payment_block} from "../utils/images";
import { Button } from "../components/core/Button";
import { countryRegion, requestPermision } from "../utils/commonMethods";
import ReactNativeBlobUtil from "react-native-blob-util";
import * as Progress from "react-native-progress";
import CommonModal from "./commonModal";
import { APP_UPDATE_URL } from "../utils/apiUrl";
import Width from "../assets/Width";
import FastImage from "../common/FastImage";
import {globalImport} from "../common/globalImports";
import {globalConfigurableData, globalConst} from "../utils/globalConstant";

const ForceUpdateScreen = ({ notNow }) => {
  const [forceUpdate, setForceUpdate] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [progressValuee, setprogressValuee] = useState(0);
  const [showError, setshowError] = useState(false);

  let globalConfigData = useSelector(
    (state) => state.utilReducer.globalConfigData
  );

  useEffect(() => {
    isForceUpdate();
  }, []);

  const isForceUpdate = () => {
    setForceUpdate(globalConfigData?.app_force_update);
  };

  const onShowError = () => {
    setshowError(!showError);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "80%",
      padding: "30px 20px 30px 20px",
      transform: "translate(-50%, -50%)",
      boxShadow: "0px 0px 2.49743px 0.832476px rgba(0, 0, 0, 0.15)",
      border: "0px",
    },
    overlay: { zIndex: 1200 },
  };

  const manualUpdate = () => {
    Linking.openURL(APP_UPDATE_URL + "?region=" + countryRegion?.region);
  };

  const ErrorModal = () => {
    return (
      <View>
        <View>
          <View style={{ alignItems: "center" }}>
            <FastImage
              style={{ height: 200, width: 200, marginBottom: 10 }}
              source={payment_block()}
            />
          </View>
          <View style={{ marginTop: 20 }}>
            <Text style={{ textAlign: "center" }}>Update Failed</Text>
          </View>
          <View style={{ marginTop: 5 }}>
            <Text style={{ textAlign: "center" }}>
              The process has been failed due to technical error. Please try to
              update manually.
            </Text>
          </View>
        </View>
        <View style={{ marginTop: 10, flex: 0 }}>
          <Button
            variant="primary"
            style={{ flex: globalImport.isWeb ? {} : 0 }}
            onPress={() => {
              if (Platform.OS === "ios") {
                Linking.openURL(
                  "https://apps.apple.com/us/app/tradex-markets/id1608795674"
                );
              } else {
                Linking.openURL(
                  APP_UPDATE_URL + "?region=" + countryRegion?.region
                );
              }
            }}
          >
            Update Manually
          </Button>
        </View>
      </View>
    );
  };

  const android = ReactNativeBlobUtil.android;

  const update = () => {
    var uri = encodeURI(APP_UPDATE_URL + "?region=" + countryRegion?.region);
    const filePath =
      ReactNativeBlobUtil.fs.dirs.DownloadDir + globalConfigurableData?.appName + "App" + ".apk";
    ReactNativeBlobUtil.config({
      addAndroidDownloads: {
        useDownloadManager: true,
        title: "TradexApp" + globalConfigData?.minBuildNumber + ".apk",
        description: "Update TradeXApp",
        mime: "application/vnd.android.package-archive",
        mediaScannable: true,
        notification: true,
        path: filePath,
      },
    })
      .fetch("GET", uri)
      .progress((received, total) => {
        // console.log('progress', received / total);
        var progressValue = received / total;
        setprogressValuee(progressValue);
      })
      .then(async (res) => {
        // console.log('Succesfull updated');
        setShowLoader(false);

        android
          .actionViewIntent(
            res.path(),
            "application/vnd.android.package-archive"
          )
          .then(() => {
            // console.log('success');
            /*ReactNativeBlobUtil.fs
              .unlink(
                ReactNativeBlobUtil.fs.dirs.DownloadDir +
                  'TradexApp' +
                  globalConfigData?.minBuildNumber +
                  '.apk',
              )
              .then(() => {
                // console.log('file is deleted');
              })
              .catch(err => {
                console.log('err', err);
              });*/
          })
          .catch((err) => {
            setshowError(true);
            console.log("error", err);
          });

        // For deleting the old files
      });
  };

  const forceUpdateApp = async () => {
    // console.log(ReactNativeBlobUtil.fs.dirs.DownloadDir +  'TradexApp' + globalConfigData?.minBuildNumber + ".apk");
    const requestPermision1 = await requestPermision("WRITE_EXTERNAL_STORAGE");
    const filePath =
      ReactNativeBlobUtil.fs.dirs.DownloadDir + "TradexApp" + ".apk";
    if (
      (Platform.Version <= 31 && requestPermision1) ||
      Platform.Version > 31
    ) {
      setShowLoader(true);
      ReactNativeBlobUtil.fs
        .unlink(filePath)
        .then(() => {
          update();
        })
        .catch((err) => {
          update();
          //console.log('err', err);
        });
    }

    //setModalVisible(true);
  };
  return (
    <View
      style={{
        flex: 1,
        paddingHorizontal: 16,
        flexDirection: "column",
      }}
    >
      {/* <CommonModal
        isOpen={showError}
        onRequestClose={onShowError}
        style={customStyles}>
        <ErrorModal />

      </CommonModal> */}

      <CommonModal
        showModal={showError}
        customModalStyle={[globalStyle.modalView, { alignItems: "stretch" }]}
        onModalCallBack={onShowError}
      >
        <ErrorModal />
      </CommonModal>

      <FastImage
          style={{
            height: 30,
            width: 80,
          }}
          source={globalConfigurableData?.logoUrl()}
      />
      <FastImage
        style={styles.img}
        source={force_update()}
      />
      <Text
        style={[
          globalStyle.headerBlue,
          { paddingTop: 16, textAlign: "center" },
        ]}
      >
        We're better than ever!
      </Text>
      <Text
        style={[{ paddingTop: 10, paddingBottom: 10, textAlign: "center" }]}
      >
        Please update the app.
      </Text>
      <View
        style={{
          backgroundColor: Color.tradexBlue,
          padding: 15,
          flex: 0,
        }}
      >
        <Text
          style={{
            color: Color.bgWhite,
            textAlign: "center",
          }}
        >
          What's new in {globalConfigData?.minBuildNumber}
        </Text>
      </View>
      <View
        style={{
          flex: 0,
          marginBottom: 20,
          padding: 10,
          backgroundColor: Color.tradexBlue1,
        }}
      >
        <FlatList
          scrollEnabled
          data={globalConfigData?.changeLogs}
          renderItem={({ item, index }) => {
            return (
              <Text style={{ color: Color.black, padding: 2 }}>• {item}</Text>
            );
          }}
          keyExtractor={(item, index) => index}
          showsVerticalScrollIndicator={false}
          initialNumToRender={10}
        />
      </View>
      {showLoader ? (
        <Progress.Bar
          progress={progressValuee}
          width={Width.width - 32}
          height={20}
          borderRadius={100}
        />
      ) : (
        <Button
          variant="primary"
          onPress={() => {
            if (Platform.OS === "ios") {
              Linking.openURL(
                "https://apps.apple.com/us/app/tradex-markets/id1608795674"
              );
            } else {
              forceUpdateApp();
            }
          }}
          style={{ flex: globalImport.isWeb ? {} : 0 }}
        >
          Update App
        </Button>
      )}
      {Platform.OS === "android" ? (
        <TouchableOpacity onPress={manualUpdate}>
          <Text
            style={[
              {
                paddingTop: 10,
                textAlign: "center",
                color: Color.yesColor,
                textDecorationLine: "underline",
              },
            ]}
          >
            Having issues? Update Manually
          </Text>
        </TouchableOpacity>
      ) : null}
      {!forceUpdate && !showLoader ? (
        <TouchableOpacity onPress={() => notNow()}>
          <Text
            style={[
              { paddingTop: 10, textAlign: "center", color: Color.yesColor },
            ]}
          >
            Not now
          </Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
};
export default ForceUpdateScreen;

const styles = StyleSheet.create({
  img: {
    width: "100%",
    height: "40%",
    alignContent: "center",
    justifyContent: "center",
  },
  button: {
    width: 100,
    height: 150,
  },
});
